import { Environment, FrontProject, SSO_REDIRECT_URL } from "./config";
import Cookies from "js-cookie";

// 获取当前页面的主域名
function getCurrentDomain() {
  const host = window.location.hostname;
  const domain = host.split(".").slice(-2).join(".");
  return domain;
}
const hostname = getCurrentDomain();
console.log("当前设置cookie hostname：", hostname);

type getTokenFn = () => string;
type setTokenFn = (token: string) => void;
type getTenantIdFn = () => string;
type setTenantIdFn = (tenantId: string) => void;
type getBidFn = () => string;
type setBidFn = (bid: string) => void;
export interface ISSOServicesOptions {
  project: FrontProject;
  env: Environment;
  getToken: getTokenFn;
  setToken: setTokenFn;
  getTenantId: getTenantIdFn;
  setTenantId: setTenantIdFn;
  getBid: getBidFn;
  setBid: setBidFn;
}

export interface IRedirectOptions {
  // 是否替换当前页面
  replace?: boolean;
  // 重定向地址
  redirect?: string;
  // 是否拼接域名
  needDomain?: boolean;
  // 是否不需要带token等参数
  disableTokenParams?: boolean;
}

// 单点登录相关服务
class SSOServices {
  // 当前实例化对象的项目
  currentFrontProject: FrontProject;
  // 环境
  env: Environment;
  // 用于获取token的方法
  getToken: getTokenFn;
  // 用于设置token的方法
  setToken: setTokenFn;
  // 用于获取tenantId的方法
  getTenantId: getTenantIdFn;
  // 用于设置tenantId的方法
  setTenantId: setTenantIdFn;
  // 用于获取bid的方法
  getBid: getBidFn;
  // 用于设置bid的方法
  setBid: setBidFn;

  constructor(options: ISSOServicesOptions) {
    // 初始化当前实例化对象的项目
    this.currentFrontProject = options.project;
    // 初始化环境
    this.env = options.env;
    // 初始化获取token的方法
    this.getToken = options.getToken;
    this.setToken = options.setToken;
    // 初始化获取tenantId的方法
    this.getTenantId = options.getTenantId;
    this.setTenantId = options.setTenantId;
    // 初始化获取bid的方法
    this.getBid = options.getBid;
    this.setBid = options.setBid;
    // 检查是否带有ssoToken和ssoTenantId和bid
    this.checkHasToken();
  }

  // 检查是否带有ssoToken和ssoTenantId
  checkHasToken() {
    // 获取ssoToken
    const ssoToken = Cookies.get("ssoToken");
    console.log("获取cookies:ssoToken----", ssoToken);
    // 获取ssoTenantId
    const ssoTenantId = Cookies.get("ssoTenantId");
    console.log("获取cookies:ssoTenantId----", ssoTenantId);
    // 获取Bid
    const ssoBid = Cookies.get("ssoBid");
    console.log("获取cookies:ssoBid----", ssoBid);
    if (ssoToken && ssoTenantId && ssoBid) {
      // 设置token
      this.setToken(ssoToken);
      // 设置tenantId
      this.setTenantId(ssoTenantId);
      // 设置ssoBid
      this.setBid(ssoBid);
      console.log("checkHasToken set token & tenantId & ssoBid success!");
      this.clearCookies();
    } else {
      console.log("checkHasToken no token & tenantId & ssoBid, set fail!");
    }
  }

  // 设置cookies
  setCookies() {
    const token = this.getToken();
    const tenantId = this.getTenantId();
    const bid = this.getBid();
    const setTokenCookieRes = Cookies.set("ssoToken", token, {
      domain: hostname,
    });
    const setSsoTenantIdCookieRes = Cookies.set("ssoTenantId", tenantId, {
      domain: hostname,
    });
    const setSsoBiIdCookieRes = Cookies.set("ssoBid", String(bid), {
      domain: hostname,
    });
    console.log("setTokenCookieRes----", setTokenCookieRes);
    console.log("setSsoTenantIdCookieRes----", setSsoTenantIdCookieRes);
    console.log("setSsoBiIdCookieRes----", setSsoBiIdCookieRes);
  }

  // 清除cookies
  clearCookies() {
    // 清除cookies的token和tenantId
    Cookies.remove("ssoToken", {
      domain: hostname,
    });
    Cookies.remove("ssoTenantId", {
      domain: hostname,
    });
    Cookies.remove("ssoBid", {
      domain: hostname,
    });
    console.log("清除cookies的token和tenantId、ssoBid成功！");
  }

  /**
   * 根据当前页面地址，替换主域名，以跳转到对应的地址
   * 主要是为了兼容当前两套域名
   * @param url
   */
  replacePrimaryDomain(url: string) {
    // 获取当前一级域名
    const currentUrl = new URL(window.location.href);
    const domainParts = currentUrl.hostname.split(".");
    const primaryDomain = domainParts.slice(-2).join("."); // 获取最后两个部分

    // 使用 URL 对象解析原始 URL
    const parsedUrl = new URL(url); // 使用 parsedUrl 作为变量名

    // 提取原始的子域名部分
    const subDomain = parsedUrl.hostname.split(".").slice(0, -2).join("."); // 获取所有子域名部分

    // 替换一级域名，同时保留所有子域名
    parsedUrl.hostname = `${subDomain ? subDomain + "." : ""}${primaryDomain}`;

    // 获取新的 URL
    return parsedUrl.toString();
  }

  // 跳转到登录页
  toLoginPage() {
    // 清除cookies的token和tenantId、ssoBid
    this.clearCookies();
    // 获取当前页面地址
    const currentUrl = window.location.href;
    // 跳转到登录页
    const redirectUrl = `${
      SSO_REDIRECT_URL[this.env][FrontProject.SSO]
    }/#/login?redirect=${encodeURIComponent(currentUrl)}&project=${
      this.currentFrontProject
    }`;
    const newUrl = this.replacePrimaryDomain(redirectUrl);
    window.location.href = newUrl;
  }

  // 页面跳转
  redirect(targetProject: FrontProject, options: IRedirectOptions) {
    const envUrlConfig = SSO_REDIRECT_URL[this.env];
    const targetProjectUrlConfig = envUrlConfig[targetProject];
    let url = "";
    if (options.redirect) {
      // 有来源页
      if (options.needDomain) {
        url = `${targetProjectUrlConfig}${options.redirect}`;
      } else {
        url = options.redirect;
      }
    } else {
      // 无来源页
      url = targetProjectUrlConfig;
    }
    if (!url) {
      return console.error("缺少跳转地址配置！");
    }
    if (!options.disableTokenParams) {
      // 需要带token等参数，设置cookies
      this.setCookies();
    }
    const newUrl = this.replacePrimaryDomain(url);
    if (options.replace) {
      window.location.href = newUrl;
    } else {
      window.open(newUrl);
    }
  }
}

export default SSOServices;
